





































import Vue from 'vue'
import ProductCard from '@/top/components/ProductCard.vue'
import { TopProductItem } from '@/top/types'
//@ts-ignore
import Swiper from 'swiper/dist/js/swiper.min.js'
import chunk from 'lodash/chunk'
import { BQ_AWS_PERSONALIZE_LOGIC_TYPE, BQ_AWS_PERSONALIZE_PAGE_TYPE, BQ_EVENT_NAMES, raksulBQEventTracker } from '@/common/utils'

const MOBILE_BREAKPOINT = 768
export default Vue.extend({
  name: 'ProductCarousel',
  components :{
    ProductCard
  },
  props: {
    carouselName: {
      type: String,
      required: true
    },
    productItems: {
      type: Array as () => TopProductItem[],
      required: true
    },
    slideChunkSize: {
      type: Number,
      default: 4
    },
    showCarouselBtn: {
      type: Boolean,
      default: false
    },
    isPersonalizeSection: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      swiper: undefined,
      currentPage: 1
    }
  },
  computed: {
    totalPage(): number {
      return this.chunkProductItems.length
    },
    chunkProductItems(): TopProductItem[][] {
      const chunkSize = this.isDesktopView ? this.slideChunkSize : 1
      return chunk(this.productItems, chunkSize)
    },
    isDesktopView(): boolean {
      return window.innerWidth > MOBILE_BREAKPOINT
    }
  },
  mounted() {
    const className = this.carouselName || 'tp-ProdCarousel_Wrapper'
    this.swiper = new Swiper(`.${className}`, {
      spaceBetween: 0,
      pagination: false,
      slidesPerView: this.isDesktopView ? 1 : 1.5,
      threshold: 2,
      loop: false,
      lazy: {
        loadPrevNext: false
      },
      navigation: {
        prevEl: `.${className} .tp-ProdCarousel_BtnPrev`,
        nextEl: `.${className} .tp-ProdCarousel_BtnNext`
      },
      on: {
        init: function() {
          if (window.lazyLoadInstance) {
            window.lazyLoadInstance.update()
          }
        },
        slideChange: () => {
          // @ts-ignore
          if (this.swiper?.swipeDirection) {
            // @ts-ignore
            if (this.swiper?.touches?.diff < 0) { this.nextPage() }
            else { this.previousPage() }
          }
      }}
    })
    this.updatePager()
  },
  methods: {
    updatePager() {
      if (this.isDesktopView) {
        this.$emit('updatePager', { currentPage: this.currentPage, totalPage: this.totalPage})
      }
    },
    previousPage(){
      if (this.currentPage === 1) {
        this.currentPage = this.totalPage
      } else {
        this.currentPage = --this.currentPage
      }
      this.updatePager()
    },
    nextPage(){
      if (this.currentPage === this.totalPage) {
        this.currentPage = 1
      } else {
        this.currentPage = ++this.currentPage
      }
      this.updatePager()
    },
    trackingProductClick(event: PointerEvent) {
      const target = event.target as HTMLElement
      const productCard = target.closest('[data-type="productCard"]')
      if (!productCard) return

      const productId = productCard.getAttribute('data-product-id')
      if (!productId) return

      if (this.isPersonalizeSection) {
        raksulBQEventTracker({
          eventName: BQ_EVENT_NAMES.CLICK_AWS_PERSONALIZE,
          data: {
            productId: productId,
            recommendationLogic: BQ_AWS_PERSONALIZE_LOGIC_TYPE.RECOMMENDED_FOR_YOU,
            pageType: BQ_AWS_PERSONALIZE_PAGE_TYPE.TOP_PAGE
          }
        })
      } else {
        raksulBQEventTracker({
          eventName: BQ_EVENT_NAMES.CLICK_MERCHANDISE,
          data: {
            productId: JSON.stringify([productId])
          }
        })
      }
      location.href = `products/${productId}`
    }
  }
})
